<template>
  <Navbar />
  <Header v-bind:title= "$t('_title_news')" />
  <Totop />
  <section v-if="articles.length">
      <ul>
        <template v-for="(article, index) in articles" :key="article.id">
          <template v-if="index >= (paginate.num-1)*paginate.size && index < paginate.num*paginate.size" >
            <li class="news-list">
              <router-link :to="{ name: 'newsDetail', params: {id: article.id} }" class="news-title" >
                <font-awesome-icon icon="fa-solid fa-angles-right" /> {{ article.title }}
              </router-link>
              <p class="post-time">
                <font-awesome-icon icon="fa-regular fa-clock" /> Posted on  {{ formattedTimestamp(article.timestamp) }}</p>
            </li>
            <hr />
          </template>
        </template>
      </ul>

      <Paginate :length="articles.length" :size="paginate.size" :num="paginate.num" @update="pageUpdate" />
  </section>
  <section v-else>
      <Loader />
  </section>

  <Footer />

</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Loader from "@/components/Loader.vue";
import Paginate from "@/components/Paginate.vue"
import Totop from "@/components/Totop.vue";

import formatted from "@/mixin/formatted";

export default {
  name: "App",
  components: { Navbar, Header, Footer, Loader, Paginate, Totop },
  mixins: [formatted],
  
  data() {
    return {
      articles: [],
      news: [],
      newsEn: [],
      paginate: {
        size:10,
        num: 1
      },

    };
  },

  methods: {
    pageUpdate(num) {
      this.paginate.num = num;
    }
  },

  watch: {
    '$i18n.locale': function(newValue){
      if(newValue == 'zh') {
        this.articles = this.news;
      }
      if(newValue == 'en') {
        this.articles = this.newsEn;
      }
    }
  },

  mounted() {
    fetch('https://oir.nccu.edu.tw/codeigniter/api/articles')
      .then((respond) => respond.json())
      .then((data) => {
        setTimeout(() => {
          this.news = data;
          if(this.$i18n.locale == 'zh'){
            this.articles = data;
          }
          
        }, 300);        
          
      })
      .catch((err) => console.log(err.message))

    fetch('https://oir.nccu.edu.tw/codeigniter/api/articlesen')
      .then((respond) => respond.json())
      .then((data) => {
        setTimeout(() => {
          this.newsEn = data;
          if(this.$i18n.locale == 'en'){
            this.articles = data;
          }
        }, 300);        
          
      })
      .catch((err) => console.log(err.message))

  }
};
</script>

<style src="@/assets/css/news.css" scoped></style>
<style src="@/assets/css/paginate.css"></style>

